import { call, put } from 'redux-saga/effects';
import { isR2RAvailableToPurchase as isR2RAvailableToPurchaseAda } from '@bitComponents/adabyron/catalog';
import { WEB_SERVICES } from './webServices';

export function* isR2RAvailableToPurchase(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
    context,
  } = params;
  try {
    const response = yield call(isR2RAvailableToPurchaseAda, context);

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.IS_R2R_AVAILABLE_TO_PURCHASE, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}
